export default __webpack_public_path__ + "8ffae6f55c46874f285af24c11e0bf6c.png";